import { useRequest } from 'ahooks'

import { createAuctionUnfreezeApplyApi } from '@eastcoal/api/trade/unfreezeApplyMember/createAuctionUnfreezeApply'

import { ConfirmButton } from '@eastcoal/common/components/Button/ConfirmButton'
import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { DepositStatus } from '@eastcoal/shared/enums/DepositStatus'

import { AuctionMemberPageStatus } from '../../../enums/AuctionMemberPageStatus'
import { useAuctionListStore } from '../../../Store/hooks/useStore'

import { DepositUnfreezeButtonProps } from './interface'

export const DepositUnfreezeButton = ({
  record: { id, status, depositStatus }
}: DepositUnfreezeButtonProps) => {
  const { message } = useFeedback()

  const { tableRef } = useAuctionListStore(state => pick(state, ['tableRef']))

  const { loading, refresh } = useRequest(
    () =>
      createAuctionUnfreezeApplyApi({
        bizId: id
      }),
    {
      manual: true,
      onSuccess() {
        message.success('申请成功')
        tableRef.current?.reload()
      }
    }
  )

  return status === AuctionMemberPageStatus.DEAL &&
    (depositStatus === DepositStatus.FREEZEN ||
      depositStatus === DepositStatus.PART_UNFREEZEN) ? (
    <ConfirmButton
      loading={loading}
      message='确定申请释放保证金吗？'
      type='link'
      onConfirm={refresh}
    >
      释放保证金
    </ConfirmButton>
  ) : null
}
